module.exports = __webpack_public_path__ + "media/5.39166846.wav";